import { useFeatureFlags } from 'utils/features';

export default function useSafetyObservationsEnabled() {
  return useFeatureFlags('SAFETY_OBSERVATIONS');
}
